import styled from '@emotion/styled';
import React from 'react';
import { theme } from 'styles/theme/theme';

interface TemplateInfoProps {
  name: string | undefined;
  version: number | string | undefined;
  objectCount: number;
  zoom: number;
}

const TemplateInfo: React.FC<TemplateInfoProps> = ({ name, version, objectCount, zoom }) => (
  <Root>
    <Row>
      <Label>Шаблон</Label>
      <Value>{name ?? '—'}</Value>
    </Row>
    <Row>
      <Label>Версия</Label>
      <Value>{version ?? '—'}</Value>
    </Row>
    <Row>
      <Label>Объекты</Label>
      <Value>{objectCount}</Value>
    </Row>
    <Row>
      <Label>Масштаб</Label>
      <Value>{zoom.toFixed(2)}×</Value>
    </Row>
  </Root>
);

export default TemplateInfo;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
`;

const Label = styled.span`
  color: ${theme.colors.Gray};
`;

const Value = styled.span`
  color: ${theme.colors.DarkBlue600};
  font-weight: 500;
`;
